<template>
    <div>
        <div class="row">
            <div v-if="loading" class="col-12 mt-5" v-loading="true"></div>
            <div v-else class="col-md-12">
                <card>
                    <template slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>Checkpoints</span>
                            <router-link v-if="userHasPermissions(['createCheckpoints'])"
                                :to="{ name: 'checkpoints-create' }">
                                <n-button type="default" size="mini">
                                    Create
                                </n-button>
                            </router-link>
                        </div>
                    </template>
                    <el-table :data="$store.state.checkpoints" class="header-background" stripe border>
                        <el-table-column label="Name" prop="name" min-width="200px" />
                        <el-table-column label="Type" prop="type" min-width="200px" />
                        <el-table-column label="QR Code" min-width="200px">
                            <template slot-scope="props">
                                <img :src="$store.state.baseUrl + props.row.qr" width="128px"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions" min-width="450px">
                            <template slot-scope="props">
                                <el-tooltip 
                                    v-if="userHasPermissions(['createCheckpoints'])"
                                    content="Clone" 
                                    placement="top">
                                    <el-button
                                        @click="clone(props.row._id)"
                                        class="btn ml-1"
                                        title="Clone"
                                        :loading="loading"
                                    >
                                        <fa icon="copy"/>
                                    </el-button>
                                </el-tooltip>
                                <router-link v-if="userHasPermissions(['viewAndCreateCheckinsForCheckpoints']) && props.row.checkinEnabled"
                                    :to="{ name: 'checkpoints-checkin', params: { type: 'checkpoint', id: props.row._id } }">
                                    <el-tooltip content="Scan" placement="top">
                                        <el-button class="btn ml-1" title="Scan">
                                            <fa :icon="['fas', 'qrcode']" />
                                        </el-button>
                                    </el-tooltip>
                                </router-link>
                                <router-link v-if="userHasPermissions(['editCheckpoints'])"
                                    :to="{ name: 'checkpoints-edit', params: { checkpointId: props.row._id } }">
                                    <el-tooltip content="Edit" placement="top">
                                        <el-button class="btn ml-1">
                                            <fa :icon="['fas', 'pen']" />
                                        </el-button>
                                    </el-tooltip>
                                </router-link>
                                <el-tooltip v-if="userHasPermissions(['createCheckpoints'])" content="Delete"
                                    placement="top">
                                    <el-button @click="remove(props.row._id)" class="btn btn-danger ml-1"
                                        title="Remove">
                                        <fa :icon="['fas', 'trash']" />
                                    </el-button>
                                </el-tooltip>
                                <router-link v-if="userHasPermissions(['viewAndCreateCheckinsForCheckpoints'])" :to="{ name: 'checkpoints-attendees', params:{ checkpointId: props.row._id } }">
                                    <el-tooltip content="Attendees" placement="top">
                                        <el-button class="btn ml-1">
                                            <fa :icon="['fas', 'users']" />
                                        </el-button>
                                    </el-tooltip>
                                </router-link>
                                <el-tooltip v-if="userHasPermissions(['editCheckpoints'])"
                                    :content="props.row.checkinEnabled ? 'Disable Checkin' : 'Enable Checkin'" placement="top">
                                    <el-switch :active-text="props.row.checkinEnabled ? 'Checkin Enabled' : 'Checkin Disabled'"
                                        class="ml-1" v-model="props.row.checkinEnabled" @change="updateCheckinEnableStatus(props.row)" id="checkin-switch" />
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import http from '../../http'

export default {
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    mounted() {
        this.getCheckpoints()
    },
    methods: {
        async updateCheckinEnableStatus(checkpoint){
            try {
                const res = await http.put('/api/checkpoints/checkin-enabled-status', { checkinEnabled: checkpoint.checkinEnabled, checkpointId: checkpoint._id })
                this.$notify({
                    message: res.data.message,
                    type: "info"
                })
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
                this.$notify({
                    message: "something went wrong",
                    type: "danger"
                })
                checkpoint.checkinEnabled = false
            }
        },
        userHasPermissions(permissions) {
            if (this.user.admin) return true;
            const roles = this.event.adminRoles && this.user._id && this.event.adminRoles[this.user._id] ? this.event.adminRoles[this.user._id] : []
            let valid = true
            permissions.forEach(per => {
                if (!roles[per]) valid = false;
            })
            return valid;
        },
        getCheckpoints: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('getAll', {
                    path: 'checkpoints',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
            } catch (e) {
                console.log('erorr getting checkpoints')
            }
            this.loading = false
        },
        remove: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the checkpoint?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (!confirmed) {
                    return
                }

                this.$store.commit('SET', ['checkpoints', this.$store.state.checkpoints.filter(checkpoint => checkpoint._id !== id)])
                this.$store.dispatch('remove', { path: 'checkpoints', id })
            } catch (e) {
                console.log(e)
                console.log('error deleting checkpoint')
            }
        },
        async clone(checkpointId){
            this.loading = true;
            try {
                const res = await http.post(`/api/checkpoints/clone`, { checkpointId, eventId: this.$route.params.eventId });
                
                this.$notify(res.data.message);
                await this.getCheckpoints()
            } catch (error) {
                this.$store.handleErrors(error);
            }
            this.loading = false;
        }
    }
}
</script>